/**
 * Social - Facebook - Share
 */
import React from 'react'

export type FacebookShareProps = {
  title: string
  url: string
}

// eslint-disable-next-line import/prefer-default-export
export const FacebookShare = ({ title, url }: FacebookShareProps) => (
  <a
    href={`https://www.facebook.com/share.php?u=${url}&title=${title}`}
    target="facebook"
  >
    <i className="fab fa-facebook-f" />
  </a>
)
